module.exports = __webpack_public_path__ + "img/LS.336b2796.png";